import React, { useState } from 'react';

const SimpleReactButton = () => {
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    console.log('React button clicked!');
    setClicked(true);
    alert('React button works!');
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>Simple React Button Test</h1>
      <p>This tests React button functionality with minimal complexity.</p>
      
      <button 
        type="button"
        onClick={handleClick}
        style={{ 
          padding: '15px 30px', 
          fontSize: '16px',
          backgroundColor: '#28a745',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}
      >
        {clicked ? 'React Button Clicked!' : 'Test React Button'}
      </button>
      
      <div style={{ margin: '20px 0', padding: '15px', backgroundColor: '#e9ecef', borderRadius: '5px' }}>
        <strong>Status:</strong> {clicked ? 'SUCCESS - React button works!' : 'Ready to test'}
      </div>
    </div>
  );
};

export default SimpleReactButton;
